import ContactList from '@/components/contact/ContactList'
import ContactCreate from '@/components/contact/ContactCreate'
import ContactVue from '@/components/contact/ContactVue'
import ContactEdit from '@/components/contact/ContactEdit'
import ContactHistory from '@/components/contact/ContactRightPanel/ContactHistory'
import ContactInformations from '@/components/contact/ContactRightPanel/ContactInformations'
import ContactOption from '@/components/contact/ContactRightPanel/ContactOptionList'
import ContactRdvList from '@/components/contact/ContactRightPanel/ContactRdvList'
import ContactSearchList from '@/components/contact/ContactRightPanel/ContactSearchList'
import ContactSalesList from '@/components/contact/ContactRightPanel/ContactSalesList'

export default [
  {
    path: '/contacts',
    name: 'ContactList',
    component: ContactList,
    meta: {
      parentName: 'Home',
      requiresAuth: true
    }
  },
  {
    path: '/contacts/creation',
    name: 'ContactCreate',
    component: ContactCreate,
    meta: {
      parentName: 'ContactList',
      requiresAuth: true
    }
  },
  {
    path: '/contacts/:id/edition',
    name: 'ContactEdit',
    component: ContactEdit,
    meta: {
      parentName: 'ContactVue',
      requiresAuth: true
    }
  },
  {
    path: '/contacts/:id',
    name: 'ContactVue',
    component: ContactVue,
    meta: {
      parentName: 'ContactList',
      requiresAuth: true
    },
    props: true,
    children: [
      {
        path: 'historique',
        name: 'ContactHistory',
        component: ContactHistory,
        meta: {
          parentName: 'ContactVue',
          requiresAuth: true
        }
      },
      {
        path: 'informations',
        name: 'ContactInformations',
        component: ContactInformations,
        meta: {
          parentName: 'ContactVue',
          requiresAuth: true
        }
      },
      {
        path: 'recherches',
        name: 'ContactSearch',
        component: ContactSearchList,
        meta: {
          parentName: 'ContactVue',
          requiresAuth: true
        }
      },
      {
        path: 'options',
        name: 'ContactOption',
        component: ContactOption,
        meta: {
          parentName: 'ContactVue',
          requiresAuth: true
        }
      },
      {
        path: 'rdvs',
        name: 'ContactRdv',
        component: ContactRdvList,
        meta: {
          parentName: 'ContactVue',
          requiresAuth: true
        }
      },
      {
        path: 'achats',
        name: 'ContactSales',
        component: ContactSalesList,
        meta: {
          parentName: 'ContactVue',
          requiresAuth: true
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/contactRouter.js